import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import Textarea from "sushiweb/InputTypes/Textarea";
import Input from "sushiweb/InputTypes/Input";
import { bindActionCreators } from "redux";
import * as TelecallerLeadsActions from "../../../store/actions/TelecallerLeads";
import styles from "../../../constants/assets/variables";
import { getInitialState, isMobile } from "../../../utils";
import variables from "../../../constants/assets/variables";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import * as UserActions from "./../../../store/actions/User";
import { removeEmptyVals } from "../../../utils";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const TeleLeadsFormModal = (props) => {
  const {
    modalState,
    handleClose,
    updateLeadEngagement,
    activeTelecaller,
    activeLeadEngagement,
    activeLead,
    rejectionReasons,
    getTelecallerLeads,
    currentPage,
    callStatuses,
    telecallerActiveFilter,
    getLeadFilterEngagement,
  } = props;
  const [disableReason, setDisableReason] = useState(false);
  const [disableFollowupDate, setDisableFollowupDate] = useState(false);
  const [formError, setFormError] = useState(false);
  const [initialState, setInitialState] = useState({
    comment: "",
    reasonId: "",
    callStatus: "",
    followupDate: "",
  });

  const checkIfReasonEnabled = (status) => {
    const filteredResults = callStatuses.filter(
      (item) => item.status === status
    );
    if (filteredResults.length > 0) {
      return filteredResults[0]["enableReason"];
    } else {
      return false;
    }
  };

  const checkIfFollowUpDateEnabled = (status) => {
    if (
      status === "AnsweredOnHold" ||
      status === "AnsweredInterestedOnHold" ||
      status === "AnsweredInterested"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    if (key === "callStatus") {
      values["reasonId"] = "";
      values["followupDate"] = "";
      if (checkIfReasonEnabled(val)) {
        setDisableReason(false);
      } else {
        setDisableReason(true);
      }
      if (checkIfFollowUpDateEnabled(val)) {
        setDisableFollowupDate(false);
      } else {
        setDisableFollowupDate(true);
      }
    }
    setInitialState(values);
    setFormError(false);
  };

  const getReasonVal = () => {
    const filteredResults = rejectionReasons.filter(
      (item) => item.id === initialState.reasonId
    );
    if (filteredResults.length > 0) {
      return filteredResults[0]["reason"];
    } else {
      return "";
    }
  };

  const getCallStatusVal = () => {
    const filteredResults = callStatuses.filter(
      (item) => item.status === initialState.callStatus
    );
    if (filteredResults.length > 0) {
      return filteredResults[0]["statusDisplay"];
    } else {
      return "";
    }
  };

  const handleSubmit = () => {
    const payload = removeEmptyVals(initialState);
    let finalPayload = {
      engagement: {
        telecaller_auth_id: activeTelecaller,
        lead_id: activeLead,
        call_status: payload.callStatus,
        reason_id: payload.reasonId,
        comment: payload.comment,
      },
      followup_date: payload.followupDate,
    };
    if (disableReason || payload.reasonId === "") {
      delete finalPayload.engagement.reason_id;
    }
    let error = formError;
    //validations
    if (
      checkIfReasonEnabled(finalPayload.engagement.call_status) &&
      finalPayload.engagement.call_status === "AnsweredNotInterested" &&
      getReasonVal(finalPayload.engagement.reason_id) === ""
    ) {
      props.setStatus({
        type: "error",
        message: "Please select reason",
      });
      error = true;
    }
    if (
      checkIfFollowUpDateEnabled(finalPayload.engagement.call_status) &&
      finalPayload.followup_date === ""
    ) {
      props.setStatus({
        type: "error",
        message: "Please select Follow Up Date",
      });
      error = true;
    }
    if (getReasonVal() === "Others" && finalPayload.engagement.comment === "") {
      props.setStatus({
        type: "error",
        message: "Please add comment",
      });
      error = true;
    }
    if (
      finalPayload.followup_date != "" &&
      new Date(finalPayload.followup_date).setHours(0, 0, 0, 0) <
        new Date().setHours(0, 0, 0, 0)
    ) {
      props.setStatus({
        type: "error",
        message: "Past date cannot be selected",
      });
      error = true;
    }

    if (!error) {
      updateLeadEngagement(finalPayload).then((res) => {
        const pageRequest = {
          page_number: currentPage,
        };
        if (Object.keys(telecallerActiveFilter).length > 0) {
          getLeadFilterEngagement(
            telecallerActiveFilter,
            pageRequest,
            activeTelecaller
          );
        } else {
          getTelecallerLeads(activeTelecaller, pageRequest);
        }
        handleClose();
      });
    }
  };

  useEffect(() => {
    //set the initial state of form in modal
    if (Object.keys(activeLeadEngagement).length > 0) {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] =
          activeLeadEngagement[key] != undefined
            ? activeLeadEngagement[key]
            : getInitialState(initialState, key);
      });
      if (checkIfReasonEnabled(values.callStatus)) {
        setDisableReason(false);
      } else {
        setDisableReason(true);
      }
      if (checkIfFollowUpDateEnabled(values.callStatus)) {
        setDisableFollowupDate(false);
      } else {
        setDisableFollowupDate(true);
      }
      setInitialState(values);
    }
  }, [activeLeadEngagement]);

  return (
    <NoFooterModal
      header
      heading="Lead Telecaller Engagement"
      handleClose={handleClose}
      id="telecallersLeadsFormModal"
      modalButtons={
        <BottomSectionModal>
          <Button
            data-testid="telecallersLeadsFormSubmitBtn"
            onClick={handleSubmit}
            className="sushi-btn"
          >
            Submit
          </Button>
        </BottomSectionModal>
      }
    >
      <TelecallerLeadsForm>
        <PaginatedReactDropdown
          options={callStatuses}
          id="statusDropdown"
          labelKey="statusDisplay"
          valueKey="status"
          labelWidth={isMobile() ? "45%" : "22%"}
          handleChange={handleChange}
          keyToChange="callStatus"
          placeholder="Select Call Status"
          showPagination={false}
          showCross
          value={getCallStatusVal()}
        />
        <PaginatedReactDropdown
          options={rejectionReasons}
          labelKey="reason"
          id="reasonDropdown"
          valueKey="id"
          labelWidth={isMobile() ? "35%" : "18%"}
          handleChange={handleChange}
          key="reasonId"
          disabled={disableReason}
          keyToChange="reasonId"
          placeholder="Select Reason"
          showPagination={false}
          showCross
          value={getReasonVal()}
        />
        <Textarea
          className={"mb-30"}
          id="sushi-textarea"
          borderColor={styles.primaryColor}
          innerWidth="100%"
          resize="none"
          label="Comment"
          onChange={(e) => handleChange("comment", e)}
          value={initialState.comment}
        />
        <Input
          borderColor={styles.primaryColor}
          id="sushi-input"
          fullWidth={true}
          value={initialState.followupDate}
          label="Follow Up Date"
          type="date"
          disabled={disableFollowupDate}
          onChange={(e) => handleChange("followupDate", e)}
        />
      </TelecallerLeadsForm>
    </NoFooterModal>
  );
};

const TelecallerLeadsForm = styled.form`
  div[aria-label="Reset"] > span > span {
    color: ${variables.red500} !important;
  }
`;

const mapStateToProps = (state) => {
  const { TelecallerLeads } = state;
  return {
    activeLeadEngagement: TelecallerLeads.activeLeadEngagement,
    currentPage: TelecallerLeads.currentPage,
    callStatuses: TelecallerLeads.callStatuses,
    telecallerActiveFilter: TelecallerLeads.activeFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateLeadEngagement: bindActionCreators(
      TelecallerLeadsActions.updateLeadEngagement,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getTelecallerLeads: bindActionCreators(
      TelecallerLeadsActions.getTelecallerLeads,
      dispatch
    ),
    getLeadFilterEngagement: bindActionCreators(
      TelecallerLeadsActions.filterLeadEngagement,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeleLeadsFormModal);
